<template>

  <div class="w-100 text-center px-3" >


    <ui-tabs fullwidth raised disableRipple>
      <ui-tab :key="1" title="Valores Recargo">
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="loadingTable"
        >
          <loading />
        </div>

        <div v-else class="px-2">

          <div style="position: relative; z-index: 1">
            <div class="d-flex" style="position: absolute">
              <agregar-recargo-modal />
              <filtros-recargos />

              <import-recharges :getRecharges="getRecargos" />

              <Button 
                class="mt-2 ml-2"
                color="#dc3545" 
                colorText="#ffffff" 
                tooltip="Eliminar seleccionados" 
                icon="fas fa-trash" 
                round 
                :width="30"
                translate 
                :inactive="checks.length < 1"
                @click.native="checks.length > 0 && deleteRechargesSelected()"
              />

              <Button
                class="mt-2 ml-2"
                color="#dc3545" 
                colorText="#ffffff" 
                tooltip="Eliminar por filtro" 
                icon="fa fa-trash-alt" 
                round 
                :width="30"  
                translate 
                :inactive="!filterStateRecargos"
                @click.native="filterStateRecargos && deleteRechargesFilters()"
              />

              <Button
                :size="15"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Exportar a Excel"
                icon="icon fas fa-file-excel"
                round
                :width="30"
                class="mt-2 ml-2"
                @click.native="actionSetShowModalFiltrosTarifasRecargos( true )"
                traslate
              />

            </div>
          </div>
          <new-data-table
            customHeaders
            numerador
            :headers="headers"
            :data="dataAux"
            :acciones="acciones"
            :max="10"
            paginacion
            buscar
            idtabla="lista_recargos"
            :seleccionar="obtenerFilaSeleccionada"
            :filaChekeada="obtenerFilaSeleccionada"
            :showAllSelectChecks="false"
            check
          />
        </div>
        <editar-recargo-modal :id="idEditar"/>
        <ver-detalle-recargo-modal :id="idVerDetalle"/>

      </ui-tab>

      <ui-tab :key="2" title="Tipos Recargos">
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="recargoTypeLoading"
        >
          <loading />
        </div>
        <div v-else class="w-100">

          <div  style="position: relative; z-index: 1">
            <div class="d-flex" style="position: absolute">
              <agregar-recargo-type-modal />
            </div>
          </div>
          <new-data-table
            withSearch
            customHeaders
            numerador
            :headers="headersTypes"
            :data="dataRechargeTypes"
            :acciones="accionesTypes"
            :max="10"
            paginacion
            buscar
            idtabla="lista_recargos_types"
            :seleccionar="obtenerFilaSeleccionada"
            exportarExcel
          />
        </div>
        
        <editar-recargo-modal-type />
        <navieras-tipo-recargo 
          :id = "idTipoRecargo"
        />

      </ui-tab>
    </ui-tabs>
  </div>
        
</template>

<script>

// Vuex
import { mapState, mapActions } from "vuex";
import Loading from "../../common/loading";
import Button from "../../common/Button";

import NewDataTable from "../../common/NewDataTable";
import AgregarRecargoModal from "../../../components/modals/lineas/tarifas/recargos/AgregarRecargoModal";
import AgregarRecargoTypeModal from "../../../components/modals/lineas/tarifas/recargos/AgregarRecargoTypeModal";

import EditarRecargoModal from "../../../components/modals/lineas/tarifas/recargos/EditarRecargoModal";
import EditarRecargoModalType from "../../../components/modals/lineas/tarifas/recargos/EditarRecargoModalType";

import VerDetalleRecargoModal from "../../../components/modals/lineas/tarifas/recargos/VerDetalleRecargoModal";
import UiTabs from "keen-ui/src/UiTabs";
import FiltrosRecargos from "../../modals/lineas/tarifas/recargos/FiltrosRecargos.vue";
import { getRecargos, deleteRecargo, validarEliminarTiposRecargos, eliminarTiposRecargos,getRechargeTypes, deleteRechargesByIds } from "../../../constants/lineas";
import ImportRecharges from '../../modals/lineas/tarifas/recargos/ImportRecharges.vue';
import NavierasTipoRecargo from '../../modals/lineas/tarifas/recargos/NavierasTipoRecargo.vue';

export default {
  props: {
    data: { type: Array, default: () => [] },
    dataRechargeTypes: { type: Array , default: () => [] },
  },
  data() {
    return {
      headers: [
        { title: "Naviera",     width: "127px" },
        { title: "Naviera Salida",     width: "127px" },
        { title: "Nombre",     width: "127px" },
        { title: "Código",     width: "100px" },
        { title: "POL",         width: "120px" },
        { title: "POD",         width: "120px" },
        { title: "Desde",       width: "120px" },
        { title: "Hasta",       width: "120px" },
        { title: "Moneda",      width: "158px" },
        { title: "Neta (Costo)",        width: "98px" },
        { title: "Venta (Pública)",        width: "98px" },
        { title: "Atmósfera",   width: "80px" },
        { title: "Unidad",      width: "80px" },
        { title: "Commodity",    width: "128px" },
        { title: "Unidad Pago", width: "60px"  },
        { title: "Acciones",    width: "128px"  },
      ],
      acciones: [],

      headersTypes: [
        { title: "Código",     width: "127px" },
        { title: "Nombre",     width: "127px" },
        { title: "Descripción",    width: "118px"  },
        { title: "Logistaas Name",    width: "118px"  },
        { title: "Acciones",    width: "118px"  },
      ],
      accionesTypes: [],

      
      dataAux: this.data,
      dataAuxTypes: this.dataRechargeTypes,
      
      
      idEditar: null,
      idVerDetalle: null,
      idEditarRecargo: null,
      idTipoRecargo : null  ,
      checks : []
    };
  },
  components: {
    Loading,
    Button,
    NewDataTable,
    AgregarRecargoModal,
    EditarRecargoModal,
    FiltrosRecargos,
    VerDetalleRecargoModal,
    AgregarRecargoTypeModal,
    EditarRecargoModalType,
    UiTabs,
    ImportRecharges,
    NavierasTipoRecargo
},
  computed: {
    ...mapState([ "loadingTable"]),

    ...mapState("lineas", ["dataDatatableTarifasRecargos",'recargoTypeLoading', 'showModalRechargesNavieras','showModalVerDetalleTarifasRecargo','filterStateRecargos']),

  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),

    ...mapActions("lineas", [
        "actionSetDataDatatableTarifasRecargos", 
        'actionSetShowModalEditarTarifasRecargo',
        'actionShowModalVerDetalleTarifasRecargo',
        'actionSetShowModalEditarRecargosType',
        'actionSetDataEditarRecargoType',
        'actionSetRecargoTypeLoading',
        'actionSetDataDatatableTarifasRecargosTypes',
        'actionSetShowModalAgregarTarifasRecargos',
        'actionSetDataDuplicarRecargoType',
        "actionSetShowModalFiltrosTarifasRecargos",
        "actionsSetShowModalRechargesNavieras",
        'actionSetRechargeTypes'
      ]),

    async deleteRechargesSelected(){

      const response = await this.$vToastify.prompt(`¿Desea eliminar ${this.checks.length} Recargo(s)?`) ;

      if( !response ) return ;

      this.eliminarRecargosByIds( this.checks ) ;

    },
    async deleteRechargesFilters(){

      const ids = this.dataAux.map( d => d.data_complementaria.id ) ; 
      
      const response = await this.$vToastify.prompt(`¿Desea eliminar ${ ids.length } Recargo(s)?`) ;

      if( !response ) return ;

      this.eliminarRecargosByIds( ids ) ;

    },
    async eliminarRecargosByIds( ids ){

      this.$vToastify.loader("Realizando Solicitud...");

      try {
      
        const payload = { ids } ;

        await deleteRechargesByIds( payload ) ;

        this.getRecargos() ;

        
        this.$vToastify.stopLoader();
        return this.$vToastify.success("Recargo(s) eliminado(s) con éxito", "Éxito");

      } catch (error) {

        this.$vToastify.error(
          "Error al eliminar Tipo de Recargo. Por favor recargue y vuelva a intentar",
          "Error"
        );

        return this.$vToastify.stopLoader();
        
      }
      


    },
    async obtenerFilaSeleccionada({id, accion , estado}) {

      switch (accion) {
        case "Editar":
          this.actionSetShowModalEditarTarifasRecargo( true );
          this.idEditar = this.dataAux[id].data_complementaria.id ;
        break;

        case "Ver Detalle":
          this.actionShowModalVerDetalleTarifasRecargo( true );
          this.idVerDetalle = this.dataAux[id].data_complementaria.id ;
        break;

        case "Eliminar Recargo": {
          const { recharges_type_name_code } = this.dataAux[id].data_complementaria ;
          const response = await this.$vToastify.prompt(`¿Desea eliminar Recargo - ${recharges_type_name_code}?`) ;
          

          if( response ){
            this.$vToastify.loader("Eliminando Recargo...");
            
            try {
              const idRecharge = +this.dataAux[id].data_complementaria.id;

              await deleteRecargo( idRecharge ) ;
              this.$vToastify.success("Recargo eliminado con éxito", "Éxito");
              this.$vToastify.stopLoader();
              await this.getRecargos() ;  

            } catch (error) {
              this.$vToastify.stopLoader();
              this.$vToastify.error(
                "Error al eliminar Recargo. Por favor recargue y vuelva a intentar",
                "Error"
              );
            }

          }
          break;
        }

        case "Duplicar Recargo" :
          this.actionSetDataDuplicarRecargoType( this.dataAux[id] );
          this.actionSetShowModalAgregarTarifasRecargos(true);
        break ;
        case "Editar Tipo Recargo" :

          this.actionSetDataEditarRecargoType( this.dataAuxTypes[id].data_complementaria ) ;

          this.actionSetShowModalEditarRecargosType(true);
        break ;

        case "Eliminar Tipo Recargo" : {
          const { code } = this.dataAuxTypes[id].data_complementaria ;
          const response = await this.$vToastify.prompt(`¿Desea eliminar el Tipo de Recargo - ${code}?`) ;

          if( !response ) break ;

          this.$vToastify.loader("Eliminando Tipo Recargo...");

          try {
            const idTypeRecharge = +this.dataAuxTypes[id].data_complementaria.id;
            
            const { data } = await validarEliminarTiposRecargos( idTypeRecharge ) ;

            if( !data.isDelete ) {
              this.$vToastify.stopLoader();

              this.$vToastify.error(
                "El Tipo de Recargo no se puede eliminar, ya que tiene valores asociados.",
                "Error"
              );
              break ;
            }
            
            await eliminarTiposRecargos(  idTypeRecharge ) ;
            this.$vToastify.stopLoader();
            this.$vToastify.success("Tipo de Recargo eliminado con éxito", "Éxito");
            await this.getRecargosTipos() ;  
            this.getRecargos()

          } catch (error) {
            this.$vToastify.stopLoader();
            this.$vToastify.error(
              "Error al eliminar Tipo de Recargo. Por favor recargue y vuelva a intentar",
              "Error"
            );
            break ;
          }


          break ;
        }

        case 'Asociar Códigos a Tipos de Recargos' :
          this.idTipoRecargo = +this.dataAuxTypes[id].data_complementaria.id ;

          this.actionsSetShowModalRechargesNavieras( true ) ;
        break ;

        case "fila_chekeada":

          estado 
            ? this.checks.push( this.dataAux[id].data_complementaria.id ) 
            : ( this.checks = this.checks.filter( check => check != this.dataAux[id].data_complementaria.id ) ) ;
          
          break;
      }
      
    },
    async getRecargosTipos(){
      
      this.actionSetRecargoTypeLoading(true);
      
      const { data } = await getRechargeTypes() ;
      
      const data_table = !data.data ? [] : data.data.map( d => ({
        data: [d.code, d.name, d.description.name, d.logistaas_code.name ],
        data_complementaria: d 
      })) ;

      this.actionSetDataDatatableTarifasRecargosTypes(data_table);
      this.actionSetRecargoTypeLoading( false ) ;
    },
    async getRecargos(){

      this.ActionSetLoadingTable(true);

      const { data } = await getRecargos() ;

      const data_table = !data.data ? [] : data.data.map( d => ({
          data: [
              d.naviera_name,
              d.naviera_departure,
              d.name,
              d.code,
              d.pol_name,
              d.pod_name,
              d.from_format,
              d.to_format,
              d.currency_name,
              d.neta,
              d.public_value,
              d.atmosphere_name,
              d.container_name,
              d.products_category_name,
              d.unit_payment_name
          ],
          data_complementaria: d 
      })) ;

      this.actionSetDataDatatableTarifasRecargos( data_table );
      this.ActionSetLoadingTable(false);
    },
    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux.map((item, index) => {

        me.acciones.push([
          {
            icon: "fa fa-copy zoom",
            title: "Duplicar Recargo",
            id: index,
          },
          {
            icon: "fa fa-edit zoom ",
            title: "Editar",
            id: index,
          },
          {
            icon: "fa fa-search zoom",
            title: "Ver Detalle",
            id: index,
          },
          {
            icon: "fa fa-times text-danger zoom",
            title: "Eliminar Recargo",
            id: index,
          },
        ]);
      });

    },

    async generarBotonesAccionesTypes() {
      let me = this;

      me.accionesTypes = [];

      await me.dataAuxTypes.map((item, index) => {

        me.accionesTypes.push([
          {
            icon: "fa fa-edit zoom ",
            title: "Editar Tipo Recargo",
            id: index,
          },
          {
            icon: "fa fa-times text-danger zoom",
            title: "Eliminar Tipo Recargo",
            id: index,
          },
          {
            icon: "fas fa-spell-check zoom",
            title: "Asociar Códigos a Tipos de Recargos",
            id: index,
          },
        ]);
      });

    },

  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },

  watch: {
    showModalVerDetalleTarifasRecargo: function (_new) {
      
      if (!_new) {
        this.idVerDetalle = null;
      }
    },
    data: function (_new) {
      let me = this;

      this.checks = [];

      if (_new) {
        me.dataAux = _new;
        this.generarBotonesAcciones();
      }
    },
    dataRechargeTypes: function( _new){

      if (_new) {
        let me = this;
        me.dataAuxTypes = _new;

        this.actionSetRechargeTypes( _new.map( rt => ({
            id   : rt.data_complementaria.id,
            name : rt.data_complementaria.code
        })) );

        this.generarBotonesAccionesTypes();
      }
    },
    showModalRechargesNavieras : function( _new ) {

        if( ! _new ) this.idTipoRecargo = null ;
      },
    
  },
};
</script>

